/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react'
import { createBrowserRouter } from 'react-router-dom'
import {
  ROUTE_ROOT,
  ROUTE_PARTNERS,
  ROUTE_PARTNERS_ALL,
  ROUTE_PARTNERS_MANUAL_ADD,
  ROUTE_RULES,
  ROUTE_RULES_ALL,
  ROUTE_CATEGORIES,
  ROUTE_GROUP,
  ROUTE_SIGN_IN,
  ROUTE_REWARDS_GRANTS,
  ROUTE_LOAN_TRANSACTION_REVIEW,
  ROUTE_CUSTOMERS,
  ROUTE_CUSTOMERS_ALL,
  ROUTE_CUSTOMER_TRANSACTIONS,
  ROUTE_TASKS,
  ROUTE_TASKS_SCRIPT_RUNS,
} from './paths'

import App from '@/App'
import ErrorPage from '@/pages/error-page/error-page'
import PartnersPageLayout from '@/pages/partners-page/partners-page-layout'
import RulesPage from '@/pages/rules-page/rules-page'
import SignInPage from '@/pages/sign-in-page/sign-in'
import CustomersPageLayout from '@/pages/customers-page/customers-page-layout'
import TasksPageLayout from '@/pages/tasks-page/tasks-page-layout'
const LazyAllPartnersPage = lazy(() => import('@/pages/partners-page/all-partners-page'))
const LazyManualAddPage = lazy(() => import('@/pages/partners-page/manual-add-page'))
const LazyRulesAllRulesPage = lazy(() => import('@/pages/rules-page/tabs/rules/all-rules'))
const LazyRulesCategoriesPage = lazy(() => import('@/pages/rules-page/tabs/categories/categories'))
const LazyRulesGroupPage = lazy(() => import('@/pages/rules-page/tabs/group/group'))
const LazyGrantsPage = lazy(() => import('@/pages/rules-page/tabs/grants/grants'))
const LazyLoanTransactionReviewPage = lazy(
  () => import('@/pages/rules-page/tabs/loan-transaction-review/loan-transaction-review')
)
const LazyAllCustomersPage = lazy(() => import('@/pages/customers-page/all-customers-page'))
const LazyCustomerTransactionsPage = lazy(() => import('@/pages/customers-page/customer-transactions-page'))
const LazyScriptRunsPage = lazy(() => import('@/pages/tasks-page/tabs/script-runs/script-runs'))

export const router = createBrowserRouter([
  {
    path: ROUTE_ROOT,
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: ROUTE_PARTNERS,
        element: <PartnersPageLayout />,
        children: [
          {
            path: ROUTE_PARTNERS_ALL,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyAllPartnersPage />
              </Suspense>
            ),
          },
          {
            path: ROUTE_PARTNERS_MANUAL_ADD,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyManualAddPage />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: ROUTE_RULES,
        element: <RulesPage />,
        children: [
          {
            path: ROUTE_RULES_ALL,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyRulesAllRulesPage />
              </Suspense>
            ),
          },
          {
            path: ROUTE_CATEGORIES,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyRulesCategoriesPage />
              </Suspense>
            ),
          },
          {
            path: ROUTE_GROUP,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyRulesGroupPage />
              </Suspense>
            ),
          },
          {
            path: ROUTE_REWARDS_GRANTS,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyGrantsPage />
              </Suspense>
            ),
          },
          {
            path: ROUTE_LOAN_TRANSACTION_REVIEW,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyLoanTransactionReviewPage />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: ROUTE_CUSTOMERS,
        element: <CustomersPageLayout />,
        children: [
          {
            path: ROUTE_CUSTOMERS_ALL,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyAllCustomersPage />
              </Suspense>
            ),
          },
          {
            path: ROUTE_CUSTOMER_TRANSACTIONS,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyCustomerTransactionsPage />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: ROUTE_TASKS,
        element: <TasksPageLayout />,
        children: [
          {
            path: ROUTE_TASKS_SCRIPT_RUNS,
            element: (
              <Suspense fallback={<div className="h-[100vh]">Loading...</div>}>
                <LazyScriptRunsPage />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: ROUTE_SIGN_IN,
        element: <SignInPage />,
      },
    ],
  },
])
